import React, { useState } from 'react'
import { Link } from 'gatsby'
import { Flex, Box, Heading, Text, Button } from 'rebass/styled-components'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import PropTypes from 'prop-types'

import TabsContainer from './TabsContainer'
import IconCard from './IconCard'
import ImageAnimations from './ImageAnimations'

const FeaturesSection = ({
  white,
  hideIcon,
  type,
  subtype,
  sixItems,
  fourItems,
  largeImg,
  noSubtitle,
  noButton,
  paddingBottom
}) => {
  const { t } = useTranslation(type)

  const tabsContent = t(`${subtype}.content`, { returnObjects: true })
  const [currentImage, setCurrentImage] = useState(
    tabsContent[Object.keys(tabsContent)[0]].imageName
  )

  return (
    <Flex
      as="section"
      flexDirection="column"
      alignItems="center"
      textAlign="center"
      justifyContent="center"
      width={1}
      pt={[20, 20, 25]}
      pb={paddingBottom ? [20, 20, 25] : [20, 20, 0]}
      sx={{
        '&': white && {
          backgroundImage: 'url(/bgFeaturePurple.png)',
          backgroundPositionY: 'top',
          backgroundRepeat: 'repeat',
          backgroundSize: 'cover'
        }
      }}
    >
      <Heading
        width={[1, 1, '640px']}
        mb={noSubtitle ? 25 : 8}
        px={[5, 5, 0]}
        variant="level2"
        color={white && 'white'}
      >
        {t(`${subtype}.title`)}
      </Heading>

      {!noSubtitle && (
        <Text
          width={white ? [1, 1, '430px'] : [1, 1, '660px']}
          mb={[15, 15, 20]}
          px={[5, 5, 0]}
          variant="level5"
          color={white && 'white'}
        >
          {t(`${subtype}.subtitle`)}
        </Text>
      )}

      <Box
        sx={{
          '@media (max-width: 80rem)': {
            display: 'none'
          }
        }}
      >
        <Flex
          alignItems="flex-start"
          justifyContent="space-between"
          flexWrap="wrap"
          maxWidth="container"
          px={[5, 5, 0]}
          sx={{
            position: 'relative'
          }}
        >
          <Box
            maxWidth={largeImg ? '600px' : '400px'}
            sx={{
              position: 'absolute',
              top: white && fourItems ? '46%' : '44%',
              left: '50%',
              transform: 'translate(-50%, -50%)',

              img: {
                height: '100%'
              }
            }}
          >
            <ImageAnimations delay={400} imageName={currentImage} />
          </Box>

          {Object.values(tabsContent).map((content, index) => (
            <Box
              width="590px"
              flex="0 50%"
              key={content.title}
              onClick={() => setCurrentImage(content.imageName)}
            >
              <IconCard
                white={white}
                type={type}
                hideIcon={hideIcon}
                active={currentImage.includes(content.imageName)}
                maxWidth={sixItems && !white ? '250px' : '300px'}
                width={1}
                mb={sixItems || fourItems ? 20 : 30}
                ml={index % 2 !== 0 ? 'auto' : ''}
                textAlign="left"
                {...content}
              />
            </Box>
          ))}
        </Flex>

        {!noButton && (
          <Link to={t(`${subtype}.button.link`)}>
            <Button
              mt={!white && 5}
              mx="auto"
              width="210px"
              variant={!white ? 'primary' : 'tertiary'}
            >
              {t(`${subtype}.button.text`)}
            </Button>
          </Link>
        )}
      </Box>

      <Box
        maxWidth="100%"
        sx={{
          '@media (min-width: 80rem)': {
            display: 'none'
          }
        }}
      >
        <TabsContainer
          content={tabsContent}
          white={white}
          type={type}
          subtype={subtype}
          hideLogos
          largeImg={largeImg}
          noTitle
          fourItems={type === 'products' && true}
          sixItems={type === 'livechat' || 'liveblog' || ('contentwall' && true)}
          inverse={true}
        />
      </Box>
    </Flex>
  )
}

FeaturesSection.propTypes = {
  white: PropTypes.bool,
  hideIcon: PropTypes.bool,
  noButton: PropTypes.bool,
  largeImg: PropTypes.bool,
  noSubtitle: PropTypes.bool,
  sixItems: PropTypes.bool,
  fourItems: PropTypes.bool,
  paddingBottom: PropTypes.bool,
  type: PropTypes.string,
  subtype: PropTypes.string
}

export default FeaturesSection
